module.exports = __webpack_public_path__ + "assets/auth0.98177746.svg";